import { css } from "@emotion/react";
import { breakpoints } from "../../../constants/mediaqueries";

export const roundedStyles = css`
    width: 2.5rem;
    height: 2.5rem;

    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const iconOnlyStyles = css`
    width: 2.5rem;
    height: 2.5rem;
    
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const launcherStyles = css`
    @media (max-width: ${breakpoints[1]}px) {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        justify-content: center;
        align-items: center;
        width: 25%;

        button, a {
            width: 3rem;
            height: 3rem;

            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;

            .btn-text {
                font-size: 12px;
            }
        }

    }
`;
